import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import axios from "axios";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import { IoIosArrowBack } from "react-icons/io";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";
import Pickup from "../../components/Pickup/Pickup";
import PickupDate from "../../components/PickupDate/PickupDate";
import TrackOrder from "../../components/TrackOrder/TrackOrder";
import TrackOrderNow from "../../components/TrackOrderNow/TrackOrderNow";
import DeliveryModal from "../DeliveryModal/DeliveryModal";
import { getOutletInformation } from "../../actions/autocompleteActions";
import { useDispatch } from "react-redux";
import CartRender from "./CartRender";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import PopUp from "../Modals/Popup";
import OutletInfo from "./OutletInfo"; //OUTLET COMPONENT FOR DETAILS REGARDING DELIVERY CHARGES
import { getSelectedOutlet } from "./outletFunctions";
import OrderPlaced from "../OrderPlaced/OrderPlaced";
import Paynow from "../PaymentMethod/Paynow";
import "../../assets/css/form.css";
import "./Rightbar.css";
import "../../assets/css/modal.css";
import cartImg1 from "../../assets/svgs/red.png";
import exclamation from "../../assets/svgs/exclamation.png";
import arrowup from "../../assets/svgs/arrow-up.svg";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RiMapPinLine, RiHomeLine, RiBankCardLine, RiTimeLine } from "react-icons/ri";
import CartIcon from "../../assets/icons/cart-icon.svg.jsx";
import ChooseModal from "../OrderItem/chooseModal";
import { useRef } from "react";
import {
  cartLocal,
  getProductsAvailability
} from "../../actions/productActions";
import {
  clearCart,
  clearPayment,
  // clearCartSingle,
  placeOrder,
  getTaxes,
  submitOrder,
  updateOrder,
  submitPayment,
  getPreparationTime,
  callCheckPickupDelivery,
  checkOutProduct
} from "../../actions/productActions";
import PaymentMethod from "../PaymentMethod/PaymentMethod";
import cartImg from "../../assets/svgs/red.png"
import { FaChevronDown } from "react-icons/fa";
const RightSidebar = (props) => {
  const { showBilling, setShowBilling } = props;
  const [showCartTotal, setShowCartTotal] = useState(false);
  const show = props.show;
  const [orderPlaced, setorderPlaced] = useState(true);
  const [showCashRegisterbanner, setShowCashRegisterbanner] = useState(false)
  const [replaceContext, setReplaceContext] = useState(null); // 👈 ADD
  const [showModal, setShowModal] = useState(false);
  const [productDataModal, setProductDataModal] = useState(null);
  // const [ShowCashRegisterbannermessage, setShowCashRegisterbannermessage] = useState(false)

  const cartIconRef = useRef(null);
  //STATE VARIABLES TO SET THE DEFAULTS THE FIRST TIME USER OPENS UP THE SIDEBAR
  const hideDelivery = props.business_location ? props.business_location[0].hide_delivery_for_web : 0
  const hidePickup = props.business_location ? props.business_location[0].hide_pickup_for_web : 0
  const [method, setMethod] = useState(1);
  const [methodText, setMethodText] = useState("Delivery");


  //----------------------------------------------------------------------------

  const [address, setAddress] = useState(null);
  const [outlate, setOutlate] = useState(null);
  const [load, setLoad] = useState(false);
  const [taxload, setTaxLoad] = useState(false);
  const [tax, setTax] = useState(null);
  const [methodToggle, setToggle] = useState(false) //Remove_Later
  const [showPickup, setShowPickup] = useState(false);
  const [showPickupDate, setShowPickupDate] = useState(false);
  const [showtrackOrder, setShowTrackOrder] = useState(false);
  const [showTrackNow, setShowTracknow] = useState(false);
  const [order, setOrder] = useState([]);
  const history = useHistory();
  const [showDelivery, setShowDelivery] = useState(false);
  const [lshow, setLshow] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [cartData, setCartData] = useState(null);
  const [SRVChargesRate, setSRVChargesRate] = useState(0);
  const [loading, setLoading] = useState(false);
  const [roundVal, setRoundVal] = useState(0);
  // const [showBilling, setShowBilling] = useState(false);
  //ORDER PLACED STATES *****************************************
  const [bshowOrderSuccess, setShowOrderSuccess] = useState(false)

  //PAYMENT METHOD STATES ***************************************
  const [bShowPayment, setShowPayment] = useState(false)
  const [paymentMethod, setPaymentMethod] = useState(null)
  const [bShowPaynow, setShowPaynow] = useState(false)
  const [paynowNumber, setPaynowNumber] = useState(localStorage.paynow_number === "null" ? null : localStorage.paynow_number)
  const [amountRoundingMethod, setAmountRoundingMethod] = useState(localStorage.amount_rounding_method === undefined ? null : localStorage.amount_rounding_method)

  const [showBlockedPopup, setShowBlockedPopup] = React.useState(false);
  const [blockedList, setBlockedList] = React.useState([]);


  //OUTLETS AND DELIVERY CHARGE STATES **************************
  const [bShowOutlet, setShowOutlet] = useState(false) //USED TO SHOW THE OUTLET MODAL FOR DELIVERY

  const [deliveryInformation, setDeliveryInformation] = useState({
    deliveryCharge: 0.0,
    deliveryOutName: "",
  });
  const [pickupRounded, setPickupRounded] = useState(0);
  const openChooseModal = (context) => {
    // context comes from CartRender
    console.log("openChooseModal called with context:", context);
    setReplaceContext(context);

    // THIS IS WHAT ChooseModal EXPECTS
    setProductDataModal({
      id: context.product.id,
      name: context.product.name,
      price: context.product.price,
      image: context.product.image,
    });

    setShowModal(true);
  };

  const [estPrepTime, setEstPrepTime] = useState(props.est_prep_time !== undefined && props.est_prep_time !== null && props.est_prep_time.length > 0 ? props.est_prep_time[0] : undefined)
  const estPrepTimeHours = estPrepTime !== undefined ? estPrepTime.est_prep_time_hours : null
  const estPrepTimeMinutes = estPrepTime !== undefined ? estPrepTime.est_prep_time_minutes : null
  const isInclusiveGST = localStorage.getItem("apply_inclusive_gst") === "true"
  // round off to the nearest

  // const amount_rounding = (number, multiple = 0) => {

  //   number = parseFloat((number).toFixed(2));//parseFloat((number.toFixed(2)) + '0'); // cut off extra value.

  //   let rounded_number = number // input value

  //   let nearestTo = parseFloat(multiple); // nearest to eg. 0.05

  //   if (multiple > 0) {

  //     let x = parseFloat((number.toFixed(2)) + '0'); // input value

  //     rounded_number = (nearestTo) * Math.round(x / nearestTo)

  //   }

  //   var output = {
  //     number: parseFloat((rounded_number.toFixed(2)) + '0'),
  //     diff: parseFloat(((rounded_number - number).toFixed(2)) + '0')
  //   }

  //   return output;
  // }
  const amount_rounding = (number, multiple = 0) => {
    number = parseFloat(number.toFixed(2));
    const nearestTo = parseFloat(multiple);

    if (!nearestTo || nearestTo <= 0) {
      return { number, diff: 0 };
    }

    // Always round DOWN (floor)
    const rounded_number = Math.floor(number / nearestTo) * nearestTo;

    // Ensure 2 decimal places
    const final_number = parseFloat(rounded_number.toFixed(2));

    // Difference will always be negative or zero
    const diff = parseFloat((final_number - number).toFixed(2));

    return { number: final_number, diff };
  };
  useEffect(() => {
    // setPaymentMethod(props.outletInfo?.method === 1 ? "Rapyd" : null);
    setPaymentMethod("Rapyd")
  }, [props.outletInfo?.method]);

  useEffect(() => {
    if (props.show) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = "auto"
    }
  }, [props.show])

  useEffect(() => {
    const orderType = localStorage.getItem("order_type");
    if (orderType === "1") {
      setMethodText("Delivery");
      setMethod(1)
    } else if (orderType === "2") {
      setMethodText("Pick Up");
      setMethod(2)
    } else {
      setMethod(1)
      setMethodText("Delivery"); // default
    }
  }, [hideDelivery])

  //   useEffect(() => {
  //   const orderType = localStorage.getItem("order_type");

  //   if (orderType === "1") {
  //     setMethodText("Delivery");
  //   } else if (orderType === "2") {
  //     setMethodText("Pick Up");
  //   } else {
  //     setMethodText("Delivery"); // default
  //   }
  // }, []);

  useEffect(() => {
    let outlet = props.outlates?.business_location?.filter(outlates => {
      return outlates.id === parseInt(localStorage.outlate)
    });
    if (outlet) {
      if (outlet.length > 0) {
        let oldOrder = order
        oldOrder["out_id"] = outlet[0].id
        oldOrder["out_name"] = outlet[0].name
        setOrder(oldOrder)
      }
    }
  }, [props.outlates]);

  useEffect(() => {
    if (!load) {
      props.getTaxes();
      setLoad(true);
    }

    if (
      props.loading === false &&
      props.tax !== null &&
      taxload === false
    ) {
      setTax(props.tax);
      setTaxLoad(true);
    }
  }, [load, props, order, taxload]);

  useEffect(() => {
    //PREVENT SUCCESS MODAL FROM SHOWING TWICE IF ON THE PAYMENT PAGE
    if (props.payment && (paymentMethod === "cash" || paymentMethod === "paynow") && history.location.pathname !== "/payment") {
      clearCart()
      setShowOrderSuccess(true)
    }
  }, [props.payment]);

  const roundoffValue = (value) => {
    const formattedTotal = parseFloat(value.toFixed(2));

    const roundingMethod = parseFloat(
      props?.business_location?.[0]?.amount_rounding_method ?? 0
    );

    let roundingAmount = 0;
    let totalAfterRounding = formattedTotal;

    if (roundingMethod > 0) {
      roundingAmount =
        ((formattedTotal * 10000) % (roundingMethod * 10000)) / 10000;

      if (roundingAmount > 0) {
        totalAfterRounding = parseFloat(
          (formattedTotal - roundingAmount).toFixed(2)
        );
        setRoundVal(roundingAmount);
        // setIsNegativeRounding(true);
      } else {
        setRoundVal(0);
        // setIsNegativeRounding(false);
      }
    } else {
      setRoundVal(0);
      // setIsNegativeRounding(false);
    }

    console.log("Rounding Amount:", roundingAmount);
    return totalAfterRounding;
  };


  useEffect(() => {
    let tempCartData = JSON.parse(localStorage.getItem("cart"));
    let gstRate = 0;
    let srvChargeRate = 0;

    if (tax) {
      tax.forEach(eachTax => {
        switch (eachTax.name) {
          case "GST":
            gstRate = eachTax.amount;
            break;
          // case "Service Charge":
          //   srvChargeRate = eachTax.amount;
          //   setSRVChargesRate(srvChargeRate);
          //   break;
          default:
            break;
        }
      });
    }

    if (tempCartData?.length) {
      let arrayTotal = tempCartData.reduce(function (acc, val) {
        return parseFloat(acc) + parseFloat(val.price);
      }, 0);

      tempCartData.sub = arrayTotal;

      // add total amout based on minimum_order_value and small_order_fee and free_delivery_order_value
      let totalFee = 0
      if (props.business_location) {
        arrayTotal = parseFloat(arrayTotal);
        let minimum_order_value = props.business_location[0].minimum_order_value != null && !isNaN(props.business_location[0].minimum_order_value) ? parseFloat(props.business_location[0].minimum_order_value) : 0;
        let delivery_fee = props.business_location[0].delivery_fee != null && !isNaN(props.business_location[0].delivery_fee) ? parseFloat(props.business_location[0].delivery_fee) : 0;
        let free_delivery_order_value = props.business_location[0].free_delivery_order_value != null && !isNaN(props.business_location[0].free_delivery_order_value) ? parseFloat(props.business_location[0].free_delivery_order_value) : 0;
        // let flat_delivery_fee = parseFloat(props.business_location[0].flat_delivery_fee) ?? 100
        let small_order_fee = props.business_location[0].small_order_fee != null && !isNaN(props.business_location[0].small_order_fee) ? parseFloat(props.business_location[0].small_order_fee) : 10;
        let appliedDeliveryFee = (method === 2) ? 0 : delivery_fee;
        // let appliedflatDeliveryFee = (method === 2) ? 0 : flat_delivery_fee;
        if (arrayTotal >= free_delivery_order_value) {
          totalFee = arrayTotal;
          tempCartData.small_order_fee = 0
          tempCartData.delivery_fee = 0
          // tempCartData.flat_delivery_fee = 0
        } else if (arrayTotal < minimum_order_value) {
          totalFee = arrayTotal + small_order_fee + appliedDeliveryFee;
          tempCartData.small_order_fee = small_order_fee
          tempCartData.delivery_fee = appliedDeliveryFee
          // tempCartData.flat_delivery_fee = appliedflatDeliveryFee
        } else {
          totalFee = arrayTotal + appliedDeliveryFee;
          tempCartData.small_order_fee = 0
          tempCartData.delivery_fee = appliedDeliveryFee
          // tempCartData.flat_delivery_fee = appliedflatDeliveryFee
        }

        tempCartData.minimum_order_value = minimum_order_value

        tempCartData.free_delivery_order_value = free_delivery_order_value

      }

      if (method === 1) {

        //let srvCharge = (arrayTotal) * (srvChargeRate / 100);
        let srvCharge = deliveryInformation?.deliveryCharge ? parseFloat(deliveryInformation?.deliveryCharge) : 0 //DELIVERYINFORMATION FROM OUTLETINFO.JS
        let gst = (arrayTotal) * (gstRate / 100);
        if (isInclusiveGST) {
          gst = arrayTotal / (100 + gstRate) * gstRate;
        }
        let billTotal = srvCharge + totalFee;
        if (!isInclusiveGST) {
          billTotal += gst;
        }
        tempCartData.srvCharge = srvCharge;
        tempCartData.gst = gst;
        tempCartData.amountRoundingDiff = 0;
        const roundedResult = roundoffValue(billTotal);
        tempCartData.sum = parseFloat(roundedResult).toFixed(2);
        tempCartData.sum_wo_tax = parseFloat(arrayTotal).toFixed(2);
      } else {
        let gst = (arrayTotal) * (gstRate / 100);
        if (isInclusiveGST) {
          gst = arrayTotal / (100 + gstRate) * gstRate;
        }
        let billTotal = totalFee;
        if (!isInclusiveGST) {
          billTotal += gst;
        }
        let finalBillTotal = roundoffValue(billTotal);
        tempCartData.srvCharge = 0;
        tempCartData.gst = gst;
        tempCartData.amountRoundingDiff = parseFloat((finalBillTotal - billTotal).toFixed(2));
        setPickupRounded(tempCartData.amountRoundingDiff);
        tempCartData.sum = parseFloat(finalBillTotal).toFixed(2);
        tempCartData.sum_wo_tax = parseFloat(arrayTotal).toFixed(2);
      }
    }

    setCartData(tempCartData);
    console.log(tempCartData)

    var serviceFee = [];
    serviceFee.push({
      'cart_count': tempCartData?.length,
      'd_charge': (tempCartData?.srvCharge ? tempCartData.srvCharge : 0).toFixed(2),
      'gst_charge': (tempCartData?.gst ? tempCartData.gst : 0).toFixed(2),
      'cart_sum_price': (tempCartData?.sum) ? tempCartData?.sum : 0,
      'cart_sum_wo_tax_price': (tempCartData?.sum_wo_tax) ? tempCartData?.sum_wo_tax : 0,
      'small_order_fee': (tempCartData?.small_order_fee) ? tempCartData?.small_order_fee : 0,
      'delivery_fee': (tempCartData?.delivery_fee) ? tempCartData?.delivery_fee : 0,
    });

    localStorage.setItem('serviceFee', JSON.stringify(serviceFee));

    if (
      props.loading === false &&
      props.add_to_cart &&
      props.add_to_cart.data &&
      Object.keys(props.add_to_cart.data).length === 0
    ) {
      props.updateCart(null);
    }

    if (
      props.loading === false &&
      !orderPlaced &&
      props.order &&
      props.order.success &&
      Object.keys(props.order.data).length > 0
    ) {
      setorderPlaced(true);
      props.closeRightbar();
      history.push("/payment/" + props.order.data.id);
    }
  }, [history, orderPlaced, props, tax, method, deliveryInformation.deliveryCharge, amountRoundingMethod]);

  useEffect(() => { //WHEN ADDRESS FROM DELIVERY MODAL CHANGES(WHEN DATA FROM ADDRESS IS SUPPLIED), TRIGGER THIS USE EFFECT
    // UNCOMMENT LATER***************************************************************************************
    // if (props.auth.isAuthenticated){ //CHECK IF USER IS LOGGED IN TO AVOID RUN-TIME ERROR
    //   const userDetails = JSON.parse(props.auth.user).data.user 

    //   if (address) {
    //     props.getOutletInformation({
    //       "latitude": address.latitude,
    //       "longtitude":  address.longtitude,
    //       "full_address": address.full_address,
    //       "customer_name": userDetails.fname,
    //       "customer_phone": userDetails.contactNo,
    //       "customer_remark": ""
    //     })
    //   }
    // }

    if (address) {
      if (props.auth?.isAuthenticated) {
        const userData = JSON.parse(localStorage.headers).data.user
        console.log(userData)
        props.getOutletInformation({
          "latitude": address.latitude,
          "longtitude": address.longtitude,
          "full_address": address.full_address,
          "customer_name": userData.fname, //CHANGE TO REAL NAME LATER,
          "customer_phone": userData.contactNo, //CHANGE TO REAL PHONE NUMBER LATER,
          "customer_remark": address.note
        })
      }
    }

  }, [address, props.auth.isAuthenticated])

  useEffect(() => {
    if (cartData !== null) {
      setEstPrepTime(props.est_prep_time !== undefined && props.est_prep_time !== null ? props.est_prep_time[0] : undefined)
    }
    if (cartData === null) {
      setEstPrepTime(undefined)
    }
  }, [cartData])

  const location = useLocation()
  useEffect(() => {
    props.getPreparationTime();

  }, [])

  const clearCart = () => {
    props.clearCart();
    localStorage.removeItem("cart");
    localStorage.removeItem("cartID");
  };

  const cartId = () => {
    if (!cartData) {
      return false;
    }

    let cartString = "";
    let cdata = cartData;

    if (cdata && Object.keys(cdata).length > 0) {
      Object.keys(cdata).map((key, index) => {
        if (!isNaN(key)) {
          cartString += cdata[key].id + ",";
        }
      });
      return cartString;
    } else {
      return false;
    }
  };

  const ProcessCheckOut = async () => {
    setLoading(true);
    try {
      let cart_id = cartId();

      if (!cart_id) {
        setPopupText("Your cart is empty!");
        setLshow(true);
        return;
      } else if (!localStorage.login) {
        setPopupText("Login is required to make payment");
        setLshow(true);
        return;
      } else if (localStorage.login && localStorage.cart) {
        if (!localStorage.d_address && method === 1) {
          setPopupText("Select Address!");
          setLshow(true);
          return;
        }
        // else if (props?.getCurrentOutlet?.name === "") {
        //   setPopupText("Select Outlet!");
        //   setLshow(true);
        //   return;
        // } 

        else if (!localStorage.outlate && method === 2) {
          setPopupText("Select Outlet!");
          setLshow(true);
          return;
        } else if (!order?.time && !localStorage.date && method === 2) {
          setPopupText("Select time and date!");
          setLshow(true);
          return;
        } else if (!deliveryInformation.deliveryOutName && method === 1) {
          setPopupText("Select delivery Outlet!");
          setLshow(true);
          return;
        } else if (!order.time) {
          setPopupText("Please select time!");
          setLshow(true);
          return;
        } else if (!paymentMethod) { // && method === 2
          setPopupText("Please select a payment method!")
          setLshow(true);
          return
        } else {
          setShowBilling(true);
        }
        // let products = cartData?.map((product, index) => {
        //   return ({
        //     product_type: "single",
        //     unit_price: product.product_price,
        //     line_discount_type: '',
        //     line_discount_amount: '',
        //     item_tax: 0.00, //fix
        //     tax_id: "", //fix
        //     sell_line_note: "", //fix
        //     modifier: (product.variation_id).split(','),
        //     modifier_price: product.variation_price,
        //     modifier_set_id: (product.variation_set_id).split(','),
        //     modifier_quantity: (product.variation_quantity).split(','),
        //     product_id: product.product_id,
        //     variation_id: product.product_variation_id,
        //     enable_stock: 0,
        //     quantity: parseFloat(product.quantity),
        //     product_unit_id: product.unit_id,
        //     base_unit_multiplier: 1,
        //     unit_price_before_discount: product.unit_price,
        //     unit_price_inc_tax: product.unit_price,
        //     weight: "",
        //     printed: product.printed
        //   });
        // });//without variation

        localStorage.setItem("time", order?.time);
        localStorage.setItem("order_type", method);
        // localStorage.setItem("products", JSON.stringify([products]));
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };
  const changeMethod = (key) => {
    if (key === 1) {
      setMethodText("Delivery");
    } else {
      setMethodText("Pick Up");
    }
    setMethod(key);

    localStorage.setItem("order_type", key);
  };
  const showPickFunction = () => {

    if (!address && method === 1) {
      setPopupText("Add your address");
      setLshow(true);
      return;
    }
    setShowPickup(true);
  };
  const pickupDateFunction = () => {
    setShowPickupDate(true);
    setShowPickup(false);
  };

  const showTrackOrderNowFunction = () => {
    setShowTrackOrder(false);
    setShowTracknow(true);
  };

  const trackOrderPage = () => {
    setShowTracknow(true);
    history.push("/track-order");
  };

  const trackOrderFunction = () => {
    setShowPickupDate(false);
    setShowTrackOrder(true);
  };

  //FUNCTION FOR MODAL POPUP(DELIVERY)
  const showDelivary = () => {
    setShowDelivery(true);
  };
  //----------------------------------
  const showOutlet = () => {
    if (!loading) {
      setShowOutlet(true)
    }
  }

  const closeOutlet = () => {
    setShowOutlet(false)
  }

  axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

  const handleProceed = async () => {
    try {
      const now = new Date();
      let checkPickupDeliverypayload = {
        "current_date": now.toISOString().split("T")[0],
        "current_time": now.toTimeString().split(" ")[0],
        "business_id": localStorage.business_id,
        "location_id": localStorage.location_id
      }

      const checkPickupDelivery = await callCheckPickupDelivery(checkPickupDeliverypayload)
      if (!checkPickupDelivery.status) {
        setPopupText(checkPickupDelivery.errorMessage ?? "Order is currently paused. Please try again later");
        setLshow(true);
        return;
      }

      if (localStorage.getItem('location_id') != null) {
        const locationId = localStorage.getItem("location_id");
        if (locationId) {
          try {
            let data = {
              location_id: locationId
            }
            const result = await axios.post("/rapyd/checkcashregister", data);
            if (result.data.status === 'closed') {
              setShowCashRegisterbanner(true)
              toast.error(result.data.message);
              // setShowCashRegisterbannermessage(result.data.message)
              return
            } else {
              setShowCashRegisterbanner(false)
              // setShowCashRegisterbannermessage("")
            }
            if (result.data.status === 'open') {
              setShowCashRegisterbanner(false)
              // setShowCashRegisterbannermessage("")
            }
          } catch (err) {
            console.error("Error:", err);
          }
        };
      }

      const buildComboPayload = (product) => {
        const combo_products_id_list = product.combo_products.map(
          (item) => item.id
        );
        const combo_products = [];

        product.combo_products_set.forEach((data) => {
          const baseId = Number(data.base_product_id);
          const setId = Number(data.product_id);
          const modId = Number(data.id);
          const modQty = Number(data.qty);
          const modPrice = Number(data.sell_price_inc_tax);

          let group = combo_products.find(
            (cp) => cp.combo_products_id === baseId
          );

          if (!group) {
            group = {
              combo_products_id: baseId,
              combo_modifier_set_id: [],
              combo_modifier: [],
              combo_modifier_quantity: [],
              combo_modifier_price: [],
            };
            combo_products.push(group);
          }

          let setIndex = group.combo_modifier_set_id.indexOf(setId);

          if (setIndex === -1) {
            group.combo_modifier_set_id.push(setId);
            group.combo_modifier.push(modId);
            group.combo_modifier_quantity.push(modQty);
            group.combo_modifier_price.push(modPrice.toString());
          } else {
            group.combo_modifier_quantity[setIndex] += modQty;
            group.combo_modifier_price[setIndex] = modPrice.toString();
            if (!group.combo_modifier.includes(modId)) {
              group.combo_modifier.push(modId);
            }
          }
        });

        return {
          combo_products_id: combo_products_id_list,
          combo_products,
        };
      };

      let products = cartData?.map((product, index) => {
        let comboPayload = null;

        if (
          Array.isArray(product?.combo_products) &&
          product.combo_products.length > 0 &&
          Array.isArray(product?.combo_products_set)
        ) {
          comboPayload = buildComboPayload(product);
        }
        return ({
          product_type: "single",
          unit_price: product.product_price,
          line_discount_type: '',
          line_discount_amount: '',
          item_tax: 0.00, //fix
          tax_id: "", //fix
          sell_line_note: "", //fix
          modifier: (product.variation_id).split(','),
          modifier_price: product.variation_price,
          modifier_set_id: (product.variation_set_id).split(','),
          modifier_quantity: (product.variation_quantity).split(','),
          product_id: product.product_id,
          variation_id: product?.product_variation_id || product?.variation_id,//product.variation_id,
          enable_stock: 0,
          quantity: parseFloat(product.quantity),
          product_unit_id: product.unit_id,
          base_unit_multiplier: 1,
          unit_price_before_discount: product.unit_price,
          unit_price_inc_tax: product.unit_price,
          weight: "",
          printed: product.printed,
          combo_products_id: comboPayload?.combo_products_id || [],
          combo_products: comboPayload?.combo_products || []

        });
      }); //variation

      if (method === 1) {
        const userData = JSON.parse(localStorage.headers).data.user
        if (address) {
          let data = {
            d_address: JSON.stringify(address),
            cart_id: cartId(),
            order_type: 1,
            ...order
          };
          data.amount_rounding_method = props?.business_location?.[0]?.amount_rounding_method ?? 0//amountRoundingMethod
          data.round_off_amount = roundVal;

          console.log("data to be sent to place order:", data)

          localStorage.setItem("deliveryInformation",
            JSON.stringify({
              ...deliveryInformation,
              customerLat: address.latitude,
              customerLong: address.longtitude,
              customerAddress: address.full_address,
              customerName: userData.fname,
              customerPhone: userData.contactNo,
              note: address.note
            }))
          // props.placeOrder(data);
          // setorderPlaced(false);
          props.closeRightbar();
          if (paymentMethod === 'Rapyd' || paymentMethod === 'rapyd') {
            await createRapydPaymentRequest(products, data)
          } else {
            history.push("/payment");
          }
        } else {
          setPopupText("Select address and time!");
          setLshow(true);
        }
        return;
      } else if (order.out_name) { //PICK UP CHECK OUT
        let data = {
          ...order,
          cart_id: cartId(),
        };
        // props.placeOrder(data);
        // setorderPlaced(false);
        props.closeRightbar();
        // console.log("amount_rounding_method", amountRoundingMethod, "round_off_amount", cartData.amountRoundingDiff)
        data.amount_rounding_method = props?.business_location?.[0]?.amount_rounding_method//amountRoundingMethod
        data.round_off_amount = roundVal;
        if (paymentMethod === "cash" || paymentMethod === "paynow") {
          let user = JSON.parse(localStorage.headers).data.user
          let date = new Date()
          date = new Date(date.toLocaleString("en-us", {
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
          }))
          let currentDate = date.toISOString().split("T")[0]
          let GOVT_TAX = ["GST", "SST"];
          const gstDetail = props.tax?.filter(i => GOVT_TAX.includes(i.name))?.[0];
          console.log("cartData.amountRoundingDiff", cartData.amountRoundingDiff, roundVal)

          var submit_data = {
            "business_id": localStorage.business_id,
            "user_id": user?.user_id,
            "location_id": localStorage.location_id,
            "sub_type": "",
            "contact_id": user?.contact_id,
            "search_product": "",
            "pay_term_number": "",
            "pay_term_type": "",
            "res_table_id": "",
            "res_waiter_id": "",
            "sell_price_tax": "includes",
            "type": "sell",
            "type_for_api": "Pickup",
            "products": products,
            "discount_type": "percentage",
            "discount_amount": 0,
            "additional_discount_method": '',
            "service_charges": 0,
            "tax_rate_id": gstDetail?.id,
            "tax_calculation_amount": gstDetail?.amount,
            "rp_redeemed": 0,
            "rp_redeemed_amount": 0,
            "shipping_details": "",
            "shipping_address": "",
            "shipping_status": "",
            "delivered_to": "",
            "shipping_charges": 0,
            "advance_balance": 0,
            "payment": [{
              "payment_id": "",
              "amount": 0.0,
              "method": paymentMethod === "paynow" ? "card" : "cash",
              "card_type": paymentMethod === "paynow" ? "paynow" : "credit"
            }],
            "sale_note": "",
            "staff_note": "",
            "change_return": 0,
            "additional_notes": "",
            "is_suspend": 0,
            "recur_interval": 1,
            "recur_interval_type": "days",
            "recur_repetitions": "",
            "subscription_repeat_on": "",
            "size": "all",
            "is_enabled_stock": "",
            "is_credit_sale": 0,
            "total_before_tax": parseFloat(cartData.sum_wo_tax),
            "final_total": parseFloat(cartData.sum_wo_tax) + parseFloat(cartData.gst),
            "amount_rounding_method": amountRoundingMethod,
            "round_off_amount": roundVal,
            "discount_type_modal": "percentage",
            "discount_amount_modal": "0",
            "order_tax_modal": "",
            "shipping_details_modal": "",
            "shipping_address_modal": "",
            "shipping_charges_modal": 0,
            "shipping_status_modal": "",
            "delivered_to_modal": "",
            "status": "final",
            "stripe_token": "",
            "first_name": "",
            "last_name": "",
            "gender": user.gender === "Male" ? 1 : 0,
            "billing_address": "",
            "city": "",
            "zip_code": "",
            "country": "",
            "phone": user?.contactNo,
            "email": user?.email,
            "accept_term_and_cond": 1,
            "occasional_offers": 0, //CHANGE LATER
            "d_address": "",
            "d_date": currentDate, // {* CHANGE LATERS}
            "d_time": data.time,
            "outlet": data.out_id,
            "pickup_completed": 0,
            "delivery_charges": 0.0,
            "platform": "foodDelivery",
            "small_order_fee": cartData?.small_order_fee,
            "is_inclusive_gst_applied": isInclusiveGST,
          };
          console.log("submit_data", submit_data)
          props.submitPayment(submit_data);
        } else if (paymentMethod === 'Rapyd' || paymentMethod === 'rapyd') {
          await createRapydPaymentRequest(products, data)
        } else {
          history.push("/payment");
        }
      } else {
        setPopupText("Select Outlet and time!");
        setLshow(true);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }

  };

  axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

  const createRapydPaymentRequest = async (products, info) => {
    try {
      props.setPaymentLoading(true);
      const now = new Date();

      const payload = {
        amount: JSON.parse(localStorage.serviceFee)[0].cart_sum_price,
        currency: "sgd",
        country: "SG",
        business_id: localStorage.getItem("business_id"),
        location_id: localStorage.getItem("location_id"),
        is_digital_ordering: 1,
        current_time: now.toLocaleTimeString("en-SG", { hour12: false }),
        current_date: now.toISOString().split("T")[0],
        platform: "foodDelivery",
        products: products,
        amount_rounding_method: info.amount_rounding_method,
        round_off_amount: info.round_off_amount,
      };
      console.log("info:", info);
      if (info?.scheduledOrder) {
        payload.scheduled_at = info.scheduledOrder.scheduled_at;
        payload.type = info.scheduledOrder.type;
      }

     const response = await axios.post("/rapyd/checkout", payload);
      const result = response.data;

      if (result.status === "success" && result.data.redirect_url) {
        const rapidPaymentPayload = {
          user: JSON.parse(localStorage.headers),
          serviceFee: JSON.parse(localStorage.serviceFee)[0],
          business_id: localStorage.getItem("business_id"),
          location_id: localStorage.getItem("location_id"),
          order_type: parseInt(localStorage.getItem("order_type")),
          products: products,//JSON.parse(localStorage.getItem("products")),
          order_id: result.data.payment.metadata.order_id,
          deliveryInformation: JSON.parse(localStorage.getItem("deliveryInformation")),
          pickup_information: info,
          tax: props.tax,
          amount_rounding_method: info.amount_rounding_method,
          round_off_amount: roundVal?.toFixed(2),
          is_inclusive_gst_applied: isInclusiveGST,
        };

        await axios.post("save_rapidpayorder", rapidPaymentPayload);

        window.location.href = result.data.redirect_url;
      } else {
        console.error("Failed to create Rapyd checkout session:", result);
        window.location.href = "payment-status?status=failed";
      }
    } catch (error) {
      console.error("Error creating Rapyd payment request:", error);
      window.location.href = "payment-status?status=failed";
    } finally {
      props.setPaymentLoading(false);
    }
  };

  const handleBack = async () => {
    setShowBilling(false);
  }
  // useEffect(() => {
  //   if (method === 1) { // Delivery
  //     setPaymentMethod("Rapyd"); // always Rapyd for Delivery
  //   }
  // }, [method]);
  useEffect(() => {
    if (method === 1) {
      if (paymentMethod !== "Rapyd") {
        setPaymentMethod("Rapyd");
      }
    } else if (method === 2) {
      if (paymentMethod) {
        setPaymentMethod(null);
      }
    }
  }, [method]);

  const getEstimationRange = (cartItems) => {
    if (!Array.isArray(cartItems) || cartItems.length === 0) {
      return "3 - 5 minutes";
    }

    const times = cartItems
      .map((item) => Number(item.estimated_time))
      .filter((time) => !isNaN(time) && time > 0);

    if (times.length === 0) {
      return "3 - 5 minutes";
    }

    const minTime = Math.min(...times);
    const maxTime = Math.max(...times);

    return minTime === maxTime
      ? `${minTime} minutes`
      : `${minTime} minutes to ${maxTime} minutes`;
  };
  const checkAvailabilityBeforeCheckout = async () => {
    try {
      if (!cartData || cartData.length === 0) {
        return { error: false, blocked: [] };
      }
      const res = await props.getProductsAvailability(cartData);
      if (!res || !res.data || res.status !== true) {
        return { error: true, blocked: [] };
      }
      const apiProducts = res.data;
      const blockedProducts = apiProducts.filter(item => {
        const product = item.localProduct;
        if (
          product?.not_for_selling === 1 ||
          product?.not_for_pickup_delivery === 1
        ) {
          return true;
        }

        const blockedModifier = product?.selectedModifiers?.some(
          m => m.out_of_stock === 1 || m.not_for_delivery === 1
        );

        if (blockedModifier) return true;

        if (product?.out_of_stock === 1) return true;

        return false;
      });
      return { error: false, blocked: blockedProducts };

    } catch (err) {
      console.error("Availability check failed:", err);

      return { error: true, blocked: [] };
    }
  };
  const isApiErrorPopup = blockedList?.length === 1
    && blockedList[0]?.name === "Unable to verify items";
  const getBlockedMessage = (item) => {
    if (item.name === "Unable to verify items") {
      return (
        <span style={{ color: "#d9534f", fontWeight: 600 }}>
          Unable to verify product availability. Please try again.
        </span>
      );
    }
    const product = item.localProduct;
    if (
      product?.not_for_selling === 1 ||
      product?.not_for_pickup_delivery === 1
    ) {
      return (
        <span>
          <strong>{item.name}</strong> is not available for selling.
          Please remove from the cart.
        </span>
      );
    }
    const blockedModifier = product?.selectedModifiers?.find(
      m => m.out_of_stock === 1 || m.not_for_delivery === 1
    );
    if (blockedModifier) {
      return (
        <span>
          <strong>{item.name}</strong> modifier is out of stock. Please choose another one.
        </span>
      );
    }
    if (product?.out_of_stock === 1) {
      return (
        <span>
          <strong>{item.name}</strong> is out of stock.
          Please remove from the cart.
        </span>
      );
    }
    return null;
  };

  return (
    <div>
      <PopUp
        text={popupText}
        show={lshow}
        closeModal={() => setLshow(false)}
        sub={cartData?.sub}
        delivery_fee={cartData?.delivery_fee}
        small_order_fee={cartData?.small_order_fee}
        gst={cartData?.gst}
        method={method}
        total={cartData?.sum}
        onProceed={handleProceed}
      />
      <DeliveryModal
        showOutlet={showOutlet}
        address={address}
        show={showDelivery}
        loginRef={props.loginRef}
        setAddress={setAddress}
        closeModal={() => setShowDelivery(false)}
        showPickupDate={() => pickupDateFunction()}
      // showCashRegister={()=> showCashRegister()}
      />

      <Pickup
        setPaynowNumber={setPaynowNumber}
        setOrder={setOrder}
        order={order}
        show={showPickup}
        closeModal={() => setShowPickup(false)}
        showPickupDate={() => pickupDateFunction()}
        setPaymentMethod={setPaymentMethod}
        setAmountRoundingMethod={setAmountRoundingMethod}
      />

      <PickupDate
        setOrder={setOrder}
        order={order}
        show={showPickupDate}
        method={method}
        address={address}
        closeModal={() => setShowPickupDate(false)}
        setShowPayment={setShowPayment}
      />

      <TrackOrder
        show={showtrackOrder}
        closeModal={() => setShowTrackOrder(false)}
        trackOrderNow={() => showTrackOrderNowFunction()}
      />

      <OutletInfo
        showOutlet={bShowOutlet}
        closeOutlet={closeOutlet}
        showPickupDate={() => pickupDateFunction()}
        setDeliveryInformation={setDeliveryInformation}
        deliveryInformation={deliveryInformation}
      />

      <PaymentMethod
        showPayment={bShowPayment}
        setPaymentVisible={setShowPayment}
        setPaymentMethod={setPaymentMethod}
        setAmountRoundingMethod={setAmountRoundingMethod}
        setShowPaynow={setShowPaynow}
        paynowNumber={paynowNumber}
        outletInfo={{ method }}


      />

      <Paynow showPaynow={bShowPaynow} setShowPaynow={setShowPaynow} paynowNumber={paynowNumber} />

      <TrackOrderNow
        show={showTrackNow}
        closeModal={() => setShowTracknow(false)}
        trackOrder={() => trackOrderPage()}
      />

      <OrderPlaced
        clearPayment={props.clearPayment}
        show={bshowOrderSuccess}
        closeModal={() => setShowOrderSuccess(false)}
        TrackOrder={() => setShowTracknow(true)}
      />

      {
        !showBilling ?
          <div className={`modal_form mycart-dropdown ${show ? "open" : ""}`} id="myCart">
            <div className="cart-head border-bottom">
              {/* Left: Method Selector */}
              <div className="cart-head-left">
                <Dropdown className="premium-dropdown">
                  <Dropdown.Toggle id="dropdown-basic" className="cart-method-btn">
                    {methodText} <FaChevronDown size={10} style={{ marginLeft: '4px' }} />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="premium-dropdown-menu">
                    {hideDelivery === 0 && (
                      <Dropdown.Item
                        onClick={() => changeMethod(1)}
                        className={method === 1 ? "active" : ""}
                      >
                        Delivery
                      </Dropdown.Item>
                    )}
                    {hidePickup === 0 && (
                      <Dropdown.Item
                        onClick={() => changeMethod(2)}
                        className={method === 2 ? "active" : ""}
                      >
                        Pick Up
                      </Dropdown.Item>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              <h2 className="cart-head-title">Cart</h2>

              {/* Right: Close */}
              <div className="cart-head-right">
                <ModalCloseButton
                  onClick={props.closeRightbar}
                  style={{ position: 'static', width: '32px', height: '32px', marginLeft: 'auto' }}
                />
              </div>
            </div>
            <div className="is" id={`${method === 2 && estPrepTime !== undefined ? 'pickup' : 'delivery'}`}>

              {/* <div className={`is`}> */}              {method === 0 ? (
                <div className="panel-ember">
                  <div className="form-group">
                    <label className="control-label label-with-icon">
                      <RiMapPinLine />
                      Deliver to
                    </label>

                    <span
                      className="btn secondry d-block f14"
                      onClick={() => showDelivary()}
                      data-testid="select_credentials"
                    >
                      {address
                        ? address.full_address
                        : " Add my address"}
                      <i className="fa fa-angle-right right"></i>
                    </span>
                  </div>

                  <div className="form-group">
                    <label className="control-label label-with-icon">
                      <RiHomeLine />
                      Select outlet
                    </label>
                    <span

                      style={address && props?.auth?.isAuthenticated
                        ? { opacity: 1.0, cursor: "pointer", pointerEvents: "auto" }
                        : { opacity: 0.4, cursor: "not-allowed", pointerEvents: "none" }
                      }
                      className="btn secondry d-block f14"
                      onClick={() => {

                        showOutlet()

                      }}
                    >
                      {deliveryInformation.deliveryOutName ? deliveryInformation.deliveryOutName : "Select your outlet"}
                      <i className="fa fa-angle-right right"></i>
                    </span>
                  </div>

                  <div className="form-group no">
                    <label className="control-label label-with-icon">
                      <RiBankCardLine />
                      Payment method</label>

                    <span
                      style={
                        address && props?.auth?.isAuthenticated ?
                          {
                            opacity: 1.0,
                            cursor: "pointer",
                            pointerEvents: "auto"
                          } :
                          {
                            opacity: 0.4,
                            cursor: "not-allowed",
                            pointerEvents: "none"
                          }
                      }
                      onClick={() => { setShowPayment(true) }}
                      className="btn secondry d-block f14"
                    >
                      {paymentMethod ? paymentMethod[0].toUpperCase() + paymentMethod.substring(1, paymentMethod.length) : "Select payment"}
                    </span>
                  </div>

                  <div className="form-group no">
                    <label className="control-label label-with-icon">
                      <RiTimeLine />
                      Delivery Time</label>
                    <span
                      onClick={() => pickupDateFunction()}
                      className="btn secondry d-block f14 pickup-btn"
                      style={
                        address && props?.auth?.isAuthenticated ?
                          {
                            opacity: 1.0,
                            cursor: "pointer",
                            pointerEvents: "auto"
                          } :
                          {
                            opacity: 0.4,
                            cursor: "not-allowed",
                            pointerEvents: "none"
                          }
                      }
                    >
                      {order.date ? order.date : "Select date and "}
                      {order.time ? order.time : "Time"}
                    </span>
                  </div>
                </div>
              ) : (
                <div className="panel-ember">

                  {method === 1 && (
                    <div className="form-group">
                      <label className="control-label">
                        <RiMapPinLine />
                        Deliver to</label>
                      <span
                        className="btn secondry d-block f14"
                        onClick={() => showDelivary()}
                        data-testid="select_credentials"
                      >
                        {address ? address.full_address : " Add my address"}
                        <i className="fa fa-angle-right right"></i>
                      </span>
                    </div>
                  )}

                  <div className="form-group">
                    <label className="control-label label-with-icon">
                      <RiHomeLine />
                      Select outlet</label>
                    {method === 1 ? (
                      <span

                        style={address && props?.auth?.isAuthenticated
                          ? { opacity: 1.0, cursor: "pointer", pointerEvents: "auto" }
                          : { opacity: 0.4, cursor: "not-allowed", pointerEvents: "none" }
                        }
                        className="btn secondry d-block f14"
                        onClick={() => {

                          showOutlet()

                        }}
                      >
                        {deliveryInformation.deliveryOutName ? deliveryInformation.deliveryOutName : "Select your outlet"}
                        <i className="fa fa-angle-right right"></i>
                      </span>) : (
                      <span
                        className="btn secondry d-block f14"
                        onClick={() => showPickFunction()}
                      >
                        {localStorage.out_name ? localStorage.out_name :
                          order.out_name ? order.out_name : "Select Outlet"}
                        <i className="fa fa-angle-right right"></i>
                      </span>)}
                  </div>

                  <div className="form-group">
                    <label className="control-label label-with-icon">
                      <RiTimeLine />
                      {method === 1 ? "Delivery Time" : "Pickup Time"}</label>

                    <span
                      onClick={() => pickupDateFunction()}
                      className="btn secondry d-block f14 pickup-btn"
                    >
                      {order.date ? order.date : "Select date and"}&nbsp;
                      {order.time ? order.time : " Time"}
                    </span>
                  </div>
                  {/*<div className="form-group no">
                    <label className="control-label">Payment method</label>

                    <div className="row xsm">
                      <div className="col-12">
                        <span
                          onClick={() => { setShowPayment(true) }}
                          className="btn secondry d-block f14"
                        >
                          {paymentMethod ? paymentMethod[0].toUpperCase() + paymentMethod.substring(1, paymentMethod.length) : "Select payment"}
                        </span>
                      </div>
                    </div>
                  </div> */}
                  <div className="form-group no">
                    <label className="control-label label-with-icon">
                      <RiBankCardLine />
                      Payment method</label>
                    <span
                      onClick={() => {
                        if (method === 2) {
                          setShowPayment(true);
                        }
                      }}
                      className="btn secondry d-block f14"
                    >
                      {method === 1
                        ? " Credit/Debit "
                        : paymentMethod
                          ? `Select payment: ${paymentMethod}`
                          : "Select payment"}
                    </span>
                  </div>

                </div>
              )}
              <div className="cart-gutter">
                {cartData && cartData.length > 0 && (
                  <div className="cart-head">
                    <span className="item">
                      {/* {props.cartData && props.cartData.count} Item(s)added */}
                      {cartData && cartData.length} Item(s)added
                    </span>
                    <button onClick={clearCart} className="btn primary action">
                      Clear Items
                    </button>

                  </div>
                )}
                <div className="cart-body">
                  {
                    cartData &&
                    cartData.length > 0 && (
                      <CartRender
                        updateCart={cartData}
                        cdata={cartData}
                        showChooseModal={openChooseModal}
                      />
                    )
                  }
                </div>
                <ChooseModal
                  show={showModal}
                  product={productDataModal}
                  replaceContext={replaceContext}
                  closeModal={() => {
                    setShowModal(false);
                    setReplaceContext(null);
                  }}
                  updateCart={(updatedOrder) => setCartData(updatedOrder)}
                />
              </div>
              {showBlockedPopup && (
                <div className="blocked-modal-overlay">
                  <div className="blocked-modal">
                    {!isApiErrorPopup && (
                      <>
                        <img src={exclamation} alt="Warning" className="warning-img" />
                        <h3 className="warning-title">Not For Selling</h3>
                      </>
                    )}

                    <div className="blocked-list">
                      {blockedList.map((item, i) => (
                        <div key={i} className="blocked-item">
                          <div style={{ fontSize: "12px", color: "#777", display: "inline" }}>
                            {getBlockedMessage(item)}
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="popup-actions">
                      <button
                        className="btn secondary"
                        onClick={() => {
                          setShowBlockedPopup(false);
                          props.closeRightbar();
                        }}
                      >
                        Explore Menu
                      </button>

                      <button
                        className="btn primary"
                        onClick={() => setShowBlockedPopup(false)}
                      >
                        Review Cart
                      </button>
                    </div>

                  </div>
                </div>
              )}
              {(!cartData || cartData.count === 0) && (
                <div style={{ padding: "40% 0", display: "flex", justifyContent: "center" }}

                >
                  <div className="empty_cart">
                    <img
                      alt="cart"
                      className="align-self-center"
                      width="90px"
                      src={cartImg1}

                    />
                    <h5 style={{ paddingTop: '5%' }}>Your cart is empty</h5>
                    <p>Add something from the menu!</p>
                  </div>
                </div>
              )}
            </div>
            {
              method === 2 && estPrepTime !== undefined ?
                <div className={'cart-prep-time'}>
                  <div className={'cart-prep-time text-container'}>
                    <div className={'cart-prep-time text'}>
                      Estimated preparation time
                    </div>
                  </div>
                  <div className={'cart-prep-time value-container'}>
                    <div className={'cart-prep-time value'}>
                      {getEstimationRange(cartData)}
                    </div>
                  </div>
                </div> :
                null
            }
            <div className={`cart-foot ${showCartTotal ? "open" : ""}`}>
              <div className="cart-table">
                <table>
                  <tbody>
                    <tr>
                      <td>Sub Total:</td>
                      <td data-testid="sub_total">
                        {cartData && cartData.sub && !isNaN(cartData.sub)
                          ? `$ ${parseFloat(cartData.sub).toFixed(2)}`
                          : "$ 0"}
                      </td>
                    </tr>
                    {method === 1 ? (<tr>
                      <td>Delivery Charge:</td>
                      <td data-testid="final_delivery_charge">
                        {cartData && cartData.delivery_fee && !isNaN(cartData.delivery_fee)
                          ? `$ ${parseFloat(cartData.delivery_fee).toFixed(2)}`
                          : "$ 0"}
                      </td>
                    </tr>) : (<tr></tr>)}

                    {cartData?.small_order_fee !== 0 ? (<tr>
                      <td>Small Order Charge</td>
                      <td data-testid="small_order_fee">
                        {cartData && cartData.small_order_fee && !isNaN(cartData.small_order_fee)
                          ? `$ ${parseFloat(cartData.small_order_fee).toFixed(2)}`
                          : "$ 0"}
                      </td>
                    </tr>) : (<tr></tr>)}

                    <tr>
                      <td>
                        GST{" "}
                        <span style={{ color: "#888", fontSize: "0.9em" }}>
                          ({isInclusiveGST ? "Inclusive" : "Exclusive"})
                        </span>
                      </td>
                      <td data-testid="GST">
                        {cartData && cartData.gst && !isNaN(cartData.gst)
                          ? `$ ${parseFloat(cartData.gst).toFixed(2)}`
                          : "$ 0"}
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
              <div className="cart" style={{ display: "flex", alignItems: "center" }}>
                <button
                  disabled={
                    method === 2 ? (order?.date && order?.time ? false : true) : false
                  }
                  onClick={async () => {

                    if (!cartData || cartData.length === 0) {
                      ProcessCheckOut();
                      return;
                    }

                    const result = await checkAvailabilityBeforeCheckout();

                    if (result.error && cartData.length > 0) {
                      setBlockedList([
                        {
                          name: "Unable to verify items",
                          localProduct: {}
                        }
                      ]);
                      setShowBlockedPopup(true);
                      return;
                    }

                    if (result.blocked.length > 0) {
                      setBlockedList(result.blocked);
                      setShowBlockedPopup(true);
                      return;
                    }

                    ProcessCheckOut();
                  }}
                  className="btn primary"
                  style={{ flex: 1 }}
                >
                  {cartData && cartData.sum ? (
                    <>
                      {loading ? (
                        <>
                          <span className="loader"></span>
                          Processing...
                        </>
                      ) : (
                        <>
                          <div style={{ textAlign: "center", width: "100%" }}>
                            <span>Next</span>
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <span>Cart is Empty</span>
                      <span>|</span>
                      <span data-testid="final_total">$ 0</span>
                    </>
                  )}
                </button>

                {/* ✅ CART BUTTON WITH INLINE DESIGN */}
                {cartData && cartData.length > 0 ? (
                  <div
                    app-data="myCart"
                    onClick={props.closeRightbar}
                  >
                    <div ref={cartIconRef} className="cart-icon" style={{ marginLeft: "10px" }}>
                      <CartIcon count={cartData?.length || 0} size={45} />
                    </div>
                  </div>
                ) : (
                  <div
                    app-data="myCart"
                    onClick={props.closeRightbar}

                  >
                    <div ref={cartIconRef} className="cart-icon" style={{ marginLeft: "10px" }}>
                      <CartIcon count={cartData?.length || 0} size={45} />
                    </div>

                  </div>
                )}
              </div>
            </div>
          </div>
          :
          <div className={`modal_form mycart-dropdown billing-mode ${show ? "open" : ""}`} id="myCart">

            {/* ── Billing Header ── */}
            <div className="billing-header">
              <button className="billing-back-btn" onClick={handleBack} aria-label="Back">
                <IoIosArrowBack size={20} />
              </button>
              <div className="billing-header-center">
                <h2 className="billing-title">Billing Summary</h2>
                <p className="billing-subtitle">
                  {method === 1 ? "Delivery order" : "Pickup order"}
                </p>
              </div>
              <ModalCloseButton
                onClick={props.closeRightbar}
                style={{ position: "static", width: "32px", height: "32px" }}
              />
            </div>

            {/* ── Billing Body ── */}
            <div className="billing-scroll">

              {/* Order Items count chip */}
              {cartData?.length > 0 && (
                <div className="billing-items-chip">
                  🛒 &nbsp;{cartData.length} item{cartData.length !== 1 ? "s" : ""} in cart
                </div>
              )}

              {/* Breakdown card */}
              <div className="billing-card">

                <div className="billing-row">
                  <span className="billing-row-label">Sub Total</span>
                  <span className="billing-row-value">
                    {cartData?.sub && !isNaN(cartData.sub)
                      ? `$${parseFloat(cartData.sub).toFixed(2)}`
                      : "$0.00"}
                  </span>
                </div>

                {method === 1 && (
                  <div className="billing-row">
                    <span className="billing-row-label">Delivery Charge</span>
                    <span className="billing-row-value">
                      {cartData?.delivery_fee && !isNaN(cartData.delivery_fee)
                        ? `$${parseFloat(cartData.delivery_fee).toFixed(2)}`
                        : "$0.00"}
                    </span>
                  </div>
                )}

                {cartData?.small_order_fee !== 0 && (
                  <div className="billing-row">
                    <span className="billing-row-label">Small Order Fee</span>
                    <span className="billing-row-value">
                      {cartData?.small_order_fee && !isNaN(cartData.small_order_fee)
                        ? `$${parseFloat(cartData.small_order_fee).toFixed(2)}`
                        : "$0.00"}
                    </span>
                  </div>
                )}

                <div className="billing-row">
                  <span className="billing-row-label">
                    GST&nbsp;
                    <span className="billing-row-tag">
                      {isInclusiveGST ? "Incl." : "Excl."}
                    </span>
                  </span>
                  <span className="billing-row-value" data-testid="GST">
                    {cartData?.gst && !isNaN(cartData.gst)
                      ? `$${parseFloat(cartData.gst).toFixed(2)}`
                      : "$0.00"}
                  </span>
                </div>

                {roundVal > 0 && (
                  <div className="billing-row billing-row--saving">
                    <span className="billing-row-label">Rounding</span>
                    <span className="billing-row-value billing-row-value--red">
                      -${roundVal.toFixed(2)}
                    </span>
                  </div>
                )}

                <div className="billing-divider" />

                <div className="billing-row billing-row--total">
                  <span className="billing-total-label">Total</span>
                  <span className="billing-total-value" data-testid="final_total">
                    {cartData?.sum && !isNaN(cartData.sum)
                      ? `$${parseFloat(cartData.sum).toFixed(2)}`
                      : "$0.00"}
                  </span>
                </div>

              </div>

              {/* Payment method badge */}
              {paymentMethod && (
                <div className="billing-pay-badge">
                  <span className="billing-pay-label">Paying via</span>
                  <span className="billing-pay-value">
                    {paymentMethod === "Rapyd" ? "💳 Credit / Debit Card" : paymentMethod}
                  </span>
                </div>
              )}

            </div>

            {/* ── Sticky Proceed Button ── */}
            <div className="billing-footer">
              <button
                className="billing-proceed-btn"
                onClick={handleProceed}
              >
                Confirm &amp; Proceed
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                  style={{ marginLeft: "8px" }}>
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </button>
            </div>

          </div>
      }

      <div
        onClick={props.closeRightbar}
        className={`app-overlay ${show ? "open" : ""}`}
      ></div>
    </div>
  );
};

RightSidebar.propTypes = {
  closeRightbar: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  add_to_cart: state.products.add_to_cart,
  order: state.products.order,
  loading: state.products.loading,
  tax: state.products.tax,
  product: state.products.product,
  outlates: state.products.outlates,
  postal: state.postal,
  auth: state.auth,
  payment: state.products.payment,
  business_location: state.products.business_location,
  est_prep_time: state.products.est_prep_time,
  getCurrentOutlet: state.products.getCurrentOutlet,
  cartData: state.products.cartLocal
});
export default withTranslation()(
  connect(mapStateToProps, { clearCart, placeOrder, getTaxes, submitOrder, updateOrder, getOutletInformation, submitPayment, clearPayment, getPreparationTime, getProductsAvailability })(
    RightSidebar
  )
);
